import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const QUARTERS = ['Q1', 'Q2', 'Q3', 'Q4'];

/**
 * YearQuarterFilter
 *
 * Props:
 *   year          — currently selected year string
 *   onYearChange  — (year: string) => void
 *   quarter       — currently selected quarter string ('' = All)
 *   onQuarterChange — (quarter: string) => void
 *   years         — array of year strings (e.g. ['2026', '2025'])
 */
const YearQuarterFilter = ({
  year = '',
  onYearChange,
  quarter = '',
  onQuarterChange,
  years = [],
}) => {
  return (
    <Box display="flex" gap={1} alignItems="center">
      <FormControl size="small" sx={{ minWidth: 100 }}>
        <InputLabel id="year-filter-label" shrink>Year</InputLabel>
        <Select
          labelId="year-filter-label"
          value={year}
          label="Year"
          displayEmpty
          onChange={(e) => onYearChange && onYearChange(e.target.value)}
        >
          <MenuItem value="">
            <em>All</em>
          </MenuItem>
          {years.map((y) => (
            <MenuItem key={y} value={y}>
              {y}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 110 }}>
        <InputLabel id="quarter-filter-label" shrink>Quarter</InputLabel>
        <Select
          labelId="quarter-filter-label"
          value={quarter}
          label="Quarter"
          displayEmpty
          onChange={(e) => onQuarterChange && onQuarterChange(e.target.value)}
        >
          <MenuItem value="">
            <em>All</em>
          </MenuItem>
          {QUARTERS.map((q) => (
            <MenuItem key={q} value={q}>
              {q}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default YearQuarterFilter;
